import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, light = false }) => (
  <p className={`mb-5 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.28em] ${light ? "text-sol" : "text-mar"}`}>
    <span className="flex h-[3px] w-12 overflow-hidden rounded-full"><span className="flex-1 bg-barro" /><span className="flex-1 bg-mar" /><span className="flex-1 bg-brasil" /></span>
    {children}
  </p>
);
